export default {
    type: 'text',
    format: {},
    default: {
        logic: 'contains'
    },
    setting: {
        logic: ['contains']
    },
    link: {},
    usage: {
        owners: ['user', 'group', 'buddies'],
        results: ['collection','play','rating','game']
    },
    lang: {
        name: 'Edition Name',
        category: ['Game'],
        description: 'Name of the specific edition (English or localised).',
        summarise: {
            prefix: 'Edition name contains'
        }
    },
    rules: {
        linked: [],
        legacy: ['version.name']
    }
}
